import {
	RawPricingProductsCollection,
	ServiceLayerRawAttachedPricingProductsData
} from '@/types/pricing';
import { RawPricingProductsResponse } from '@/types/i-request-results';
import CookieHandler from '@/plugins/cookie-handler';
import store from '@/store';

class ServiceLayerRequestsHandler {
	private get baseUrl(): string {
		return store.getters.serviceLayerRelayServiceUrl();
	}

	private get campaignId(): string {
		const id = store.getters.campaignId();
		return id.toString();
	}

	public async retrieveRawAttachedPricingProductsData(): Promise<ServiceLayerRawAttachedPricingProductsData> {
		const body = { campaignID: this.campaignId };
		const options = {
			method: 'POST',
			body: JSON.stringify(body),
			headers: {
				Authorization: CookieHandler.retrieveTokenIdCookie()
			}
		};

		const response = await fetch(
			`${this.baseUrl}/campaigns/retrieve-entity-config-by-campaign-id`,
			options
		);
		if (!response.ok) {
			throw new Error('Something went wrong while retrieving pricing data using the SL Relay Service.');
		}

		return (await response.json()) as ServiceLayerRawAttachedPricingProductsData;
	}

	public async retrieveRawPricingProductsData(): Promise<RawPricingProductsCollection> {
		const options = {
			method: 'GET',
			headers: {
				Authorization: CookieHandler.retrieveTokenIdCookie()
			}
		};

		const response = await fetch(`${this.baseUrl}/products/retrieve-all`, options);
		if (!response.ok) {
			throw new Error('Something went wrong while retrieving pricing data using the SL Relay Service.');
		}

		const result = (await response.json()) as RawPricingProductsResponse;
		return result.products;
	}
}

export default new ServiceLayerRequestsHandler();
